import { gsap } from 'gsap'

document.addEventListener('DOMContentLoaded', () => {

  var ww = window.innerWidth;
  var hh = window.innerHeight;
  var footer_top = $(".globalFooter").offset().top;

  const $header = $(".globalHeader");
  const $header_contents = $(".header_contents");
  const $goods = $(".goods");
  const $ma_t = $(".more .ma-t");
  const $comment = $(".more .comment");
  const $exhibition = $(".more .exhibition");
  const $ma_t_fix = $(".ma-t");
  const $comment_fix = $(".comment");
  const $exhibition_fix = $(".exhibition");
  const $fixed_buy_btn = $(".fixed_buy_btn");
  const $para_fast = $('.para_fast');
  const $para_slow = $('.para_slow');
  const $area = $('.area');
  const $about = $(".about");

  var area_top = $area.offset().top;
  var about_top = $about.offset().top;
  var ma_t_top = $ma_t.offset().top;
  var comment_top = $comment.offset().top;
  var exhibition_top = $exhibition.offset().top;

  $(window).on('load', function() {

    $('body').addClass('load');
    $header.height(hh);

    if (Useragnt.ios){
      $("meta[name='viewport']").attr('content','width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    if(ww < 771){
      var mySwiper = new Swiper ('.swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        speed: 8000,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        }
      });
    }

    op_anim();

  });

  //GAの設定
  $(document).on("click", ".buy_btn", function(){
    var send_val = 'top-buy';
    gtag('event', 'click', {'event_category': 'mw','event_label': send_val,'value': '1'});
  });
  $(document).on("click", ".fixed_buy_btn", function(){
    ww = window.innerWidth;
    if(ww > 770){
      var send_val = 'fixed-buy-pc';
    } else {
      var send_val = 'fixed-buy-sp';
    }
    gtag('event', 'click', {'event_category': 'mw','event_label': send_val,'value': '1'});
  });
  $(document).on("click", ".button", function(){
    ww = window.innerWidth;
    if(ww > 770){
      var send_val = 'info-buy-pc';
    } else {
      var send_val = 'info-buy-sp';
    }
    gtag('event', 'click', {'event_category': 'mw','event_label': send_val,'value': '1'});
  });
  $(document).on("click", ".best_btn", function(){
    ww = window.innerWidth;
    if(ww > 770){
      var send_val = 'best-btn-pc';
    } else {
      var send_val = 'best-btn-sp';
    }
    gtag('event', 'click', {'event_category': 'mw','event_label': send_val,'value': '1'});
  });
  $(document).on("click", ".series .about_btn", function(){
    ww = window.innerWidth;
    if(ww > 770){
      var send_val = 'series-about-pc';
    } else {
      var send_val = 'series-about-sp';
    }
    gtag('event', 'click', {'event_category': 'mw','event_label': send_val,'value': '1'});
  });
  $(document).on("click", ".system .about_btn", function(){
    ww = window.innerWidth;
    if(ww > 770){
      var send_val = 'system-about-pc';
    } else {
      var send_val = 'system-about-sp';
    }
    gtag('event', 'click', {'event_category': 'mw','event_label': send_val,'value': '1'});
  });


  function scrollShow() {
    $('.scroll-show').each(function(i, elm) {

      const $wh = $(window).height();
      const $st = $(window).scrollTop();
      const $sb = $st + $wh * .75;

      if ($(elm).is('.is-show')) {
        return true;
      }

      const $pos = $(elm).offset().top;
      if ($pos < $sb) {
        $(elm).addClass('is-show');
      }
      return;
    });
  }

  function op_anim(){

    TweenMax.to("body", 0.5,{
      opacity: 1
    });
    TweenMax.to(".loading", 0.5,{
      delay: 4,
      opacity: 0
    });
    TweenMax.to(".title_anim", 0,{
      delay: 5,
      opacity: 1,
      onComplete : function(){
        $(".title_anim").addClass("move");
      }
    });
    TweenMax.to(".title_img", 1.5,{
      delay: 6,
      opacity: 1,
      "padding-top": 0
    });
    TweenMax.to(".goods", 1.5,{
      delay: 6,
      opacity: 1
    });
    TweenMax.to(".goods img", 1.5,{
      delay: 6,
      "padding-top": 0
    });
    TweenMax.to(".para_fast", 1.5,{
      delay: 6,
      opacity: 1
    });
    TweenMax.to(".para_slow", 1.5,{
      delay: 6.5,
      opacity: 1
    });
    TweenMax.to(".title p", 1,{
      delay: 8,
      opacity: 1
    });
    TweenMax.to(".illust", 1,{
      delay: 8,
      opacity: 1
    });
    TweenMax.to(".scroll", 1,{
      delay: 8,
      opacity: 1
    });
    TweenMax.to(".buy_btn", 1,{
      delay: 8,
      opacity: 1,
      onComplete : function(){
        $("body").css("position","relative");
        $("body").css("overflow","visible");

        if(ww > 770){
          luxy.init({
            wrapperSpeed:  0.08
          });
        }
      }
    });
  }

  function moreShow(scr, hh, scr_hh){
    var scr_half = scr+(hh*0.5);

    var set_hh = (hh*.4);
    if(ww > 770){
      set_hh = (hh*.6);
    }

    if(ma_t_top < scr_half){
      if(comment_top > scr_hh){
        $ma_t_fix.addClass("show");
        $(".ma-t .more_set").css("top", set_hh-((scr-20)/10) + 'px');
      } else {
        $ma_t_fix.removeClass("show");
      }
    } else {
      $ma_t_fix.removeClass("show");
    }
    if(comment_top < scr_half){
      if(exhibition_top > scr_hh){
        $comment_fix.addClass("show");
        var com_scr = scr-hh;
        $(".comment .more_set").css("top", set_hh-(com_scr/10) + 'px');
      } else {
        $comment_fix.removeClass("show");
      }
    } else {
      $comment_fix.removeClass("show");
    }
    if(exhibition_top < scr_half){
      if(area_top > scr_hh){
        $exhibition_fix.addClass("show");
        var exh_scr = scr - hh*2.5;
        $(".exhibition .more_set").css("top", set_hh-(exh_scr/10) + 'px');
      } else {
        $exhibition_fix.removeClass("show");
      }
    } else {
      $exhibition_fix.removeClass("show");
    }
  }

  $(window).scroll(function() {

    var scr = $(window).scrollTop();
    var scr_hh = scr + hh;

    if ($('body').hasClass('load')) {
      scrollShow();
      moreShow(scr, hh, scr_hh);
    }

    //水滴のパララックス
    $para_fast.stop(true, true).animate({
			'background-position-y': -scr / 3 + 'px'
		}, 100);
    $para_slow.stop(true, true).animate({
			'background-position-y': -scr / 5 + 'px'
		}, 100);

    //goodsの固定
    if(scr_hh > area_top){
      if(!$goods.hasClass("stop")){
        $goods.addClass("stop");
        $goods.css("top", scr );
      }
    } else {
      $goods.removeClass("stop");
      $goods.css("top", 0 );
    }

    if(scr > 0){
      $goods.addClass("move");
      $header_contents.addClass("move");
      $fixed_buy_btn.addClass("move");
    } else {
      $goods.removeClass("move");
      $header_contents.removeClass("move");
      $fixed_buy_btn.removeClass("move");
    }
    //購入ボタン
    if(scr > 50){
      $fixed_buy_btn.addClass("move");
    } else {
      $fixed_buy_btn.removeClass("move");
    }
    if(scr_hh > footer_top){
      $fixed_buy_btn.removeClass("move");
    }

  });

  $(window).resize(function() {

    ww = window.innerWidth;
    hh = window.innerHeight;
    area_top = $area.offset().top;
    about_top = $about.offset().top;
    footer_top = $(".globalFooter").offset().top;
    ma_t_top = $ma_t.offset().top;
    comment_top = $comment.offset().top;
    exhibition_top = $exhibition.offset().top;

    if(ww > 770){
      $header.height(hh);
    }

  });


});
